<app-modal
  #deleteDocsModal
  [modalMessage]="app.text.table.deleteNotification"
  [modalTitle]="app.text.alert.modalTitle"
  (ok)="deleteChangesDocs()"
  >
</app-modal>
<app-paginator
  [length]="app.change.changes.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
@if (app.table.selected.size > 0) {
  <div class="row">
    <div class="col-md-4 ps-1">
      <div class="d-inline-flex selectedAlerts">
        @if (app.table.selected.size > 0) {
          <a
            class="me-3 pointer"
            (click)="markAsSeeen()"
            >
            <i class="fas fa-check-double fa-green"></i> &nbsp;
            {{ app.text.change.markAsSeen }}
          </a>
        }
        @if (app.table.selected.size > 0) {
          <a
            class="pointer"
            (click)="deleteDocsModal.open()"
            >
            <i class="fas fa-trash"></i> &nbsp;
            {{ app.text.alert.deleteAllSelected }}
          </a>
        }
      </div>
    </div>
    <div class="col-md-4 text-center">
      <div class="text-center d-inline-flex selectedAlerts">
        <span> {{ app.table.selected.size }} {{ app.text.mail.selected }} </span>
        @if (app.table.selected.size !== app.change.changes.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.selectAll(app.change.changes, true)"
            >
            {{ app.text.mail.selectAll }} {{ app.change.changes.length }}
          </a>
        }
        @if (app.table.selected.size === app.change.changes.length) {
          <a
            class="selectAllButtton"
            (click)="app.table.clearSelection()"
            >
            {{ app.text.mail.deselectAll }}
          </a>
        }
      </div>
    </div>
  </div>
}
<div>
  <div
    class="tableFixHead"
    [ngClass]="{
      'table-responsive-style': app.customers.expectCurrent === 'db',
      tableHeight: app.filterTable.isDropdownOpen
    }"
    >
    <table class="table table-striped spacing-table">
      <thead>
        <tr>
          @for (column of columns; track column) {
            <th class="p-1">
              <div class="d-inline-flex">
                <div
                [ngClass]="{
                  'resize-table': app.table.canColumnBeResized(column)
                }"
                  >
                  <span
                  (click)="
                    app.table.toggleSortDirection(column);
                    app.table.sort(app.change.changes)
                  "
                    >
                    {{ app.field.handleSpecialLogicLabels(column) }}
                  </span>
                </div>
                &nbsp;
                @if (column === app.table.sortField) {
                  <span>
                    @if (app.table.sortDirection === 1) {
                      <i
                        class="fa fa-chevron-up"
                      ></i>
                    }
                    @if (app.table.sortDirection === -1) {
                      <i
                        class="fa fa-chevron-down"
                      ></i>
                    }
                  </span>
                }
              </div>
              @if (column === 'select') {
                <div>
                  @if (
                    app.table.selected.size === app.change.changes.length &&
                    app.change.changes.length
                    ) {
                    <button
                      class="btn btn-hidden pt-0 ps-0"
                      (click)="app.table.clearSelection()"
                      >
                      <i class="far fa-check-square"></i>
                    </button>
                  }
                  @if (app.table.selected.size === 0) {
                    <button
                      class="btn btn-hidden pt-0 ps-0"
                      (click)="app.table.selectAll(app.change.changes)"
                      >
                      <i class="far fa-square"></i>
                    </button>
                  }
                </div>
              }
              @if (app.filterTable.getFilterTableColumns(column)) {
                <div>
                  <app-filter-table
                    [column]="app.mail.getColumnShort(column)"
                    [columns]="columnsShort"
                    [docType]="'change'"
                    [cleanDocs]="app.change.cleanChanges"
                    [selectedFilters]="selectedFilters"
                (resultedDocs)="
                  app.filterTable.getFilterResults($event, 'change')
                "
                    >
                  </app-filter-table>
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (change of app.paginator.getPage(app.change.changes); track change) {
          <tr
            class="p-1"
            [ngClass]="{ read: change.seen }"
            class="pointer"
          (click)="
            markAsSeeen(change);
            changeNavigationByCustomer(app.customer, change)
          "
            >
            @for (column of columnsShort; track column) {
              <td class="p-1">
                <div>
                  @switch (app.table.getColumnTypeDisplay(column)) {
                    @case ('time') {
                      <div>
                        {{ change[column] | date : "yyyy-MM-dd HH:mm:ss" }}
                      </div>
                    }
                    @case ('normal') {
                      <div>
                        {{ change[column] }}
                      </div>
                    }
                    @case ('artNumber') {
                      <div>
                        {{ change[column] }}
                      </div>
                    }
                    @case ('optionText') {
                      <div>
                        <span>
                          {{
                          app.field.getOptionText("change." + column, change[column])
                          }}
                        </span>
                      </div>
                    }
                    @case ('actions') {
                      <div>
                        @if (column === 'seen') {
                          <div>
                            @if (change.update_user !== undefined && change[column]) {
                              <button
                                class="btn btn-hidden pt-0 ps-0"
                    [ngbTooltip]="
                     app.users.getOptionName(change.update_user) +
                      ' ' +
                      app.text.credits.on +
                      ' ' +
                      (change.update_time | date : 'yyyy-MM-dd')
                    "
                                >
                                <i class="fas fa-check-double fa-green"></i>
                              </button>
                            }
                            @if (change.update_user == undefined && change[column]) {
                              <button
                                class="btn btn-hidden pt-0 ps-0"
                                >
                                <i class="fas fa-check-double fa-green"></i>
                              </button>
                            }
                            @if (!change[column]) {
                              <button
                                class="btn btn-hidden pt-0 ps-0"
                                >
                                <i class="fas fa-exclamation-circle fa-orange"></i>
                              </button>
                            }
                          </div>
                        }
                        @if (column === 'select') {
                          <div>
                            @if (!change[column]) {
                              <button
                                class="btn btn-hidden pt-0 ps-0"
                    (click)="
                      app.table.toggleSelect(change); $event.stopPropagation()
                    "
                                >
                                @if (app.table.selected.has(change)) {
                                  <i
                                    class="far fa-check-square"
                                  ></i>
                                }
                                @if (!app.table.selected.has(change)) {
                                  <i
                                    class="far fa-square"
                                  ></i>
                                }
                              </button>
                            }
                          </div>
                        }
                      </div>
                    }
                    @case ('getUser') {
                      <div>
                        {{app.users.getOptionName(change[column])}}
                      </div>
                    }
                  }
                </div>
              </td>
            }
          </tr>
        }
        <tr>
          @if (loading) {
            <td colspan="99" class="text-center">
              {{ this.app.text.core.loading }}
            </td>
          }
          @if (!loading && app.change.changes.length === 0) {
            <td
              colspan="99"
              class="text-center"
              >
              {{ app.text.app.noResults }}
            </td>
          }
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-paginator
  [length]="app.change.changes.length"
  [index]="app.paginator.focus"
  (focus)="app.paginator.focus = $event"
></app-paginator>
